module.exports = __webpack_public_path__ + "img/suhas-bendre.c886e157.png";